import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    nodeMap: new Map(),
    isEdit: null,
    selectedNode: {},
    selectFormItem: null,
    design: {
      // deptIds: [],
      // deptNames: [],
      // projectIds: [],
      // projectNames: [],
      // menuName: "",
      // groupId: [],

    },
    runningList: [],
    noTakeList: [],
    endList: [],
    diagramMode: 'design',
  },
  mutations: {
    selectedNode (state, val) {
      state.selectedNode = val
    },
    loadForm (state, val) {
      state.design = val
      // console.log(val, 'valvalvalvalvalval---------------------------------------------------')
      // state.design = { ...val }
      // state.deptIds: [],
      // state.deptNames: [],
      // stateprojectIds: [],
      // projectNames: [],
      // menuName: "",
      // groupId: [],
    },
    setIsEdit (state, val) {
      state.isEdit = val
    }
  },
  getters: {},
  actions: {},
  modules: {}
})
